import React from 'react';
import { Button } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Sizes = () => {
  return (
    <>
      <h4 className="mt-5">Sizes</h4>
      <p>
        Get small or large buttons easily by using the <i>size</i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <Button className="single-btn" size="small">
          Small
        </Button>
        <Button className="single-btn">Default</Button>
        <Button className="single-btn" size="large">
          Large
        </Button>
        <Button className="single-btn" size="extraLarge">
          Extra Large
        </Button>
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Button } from "chic-ui";'}
          <br />
          {'<Button size="small">Small</Button>'}
          <br />
          {'<Button size="default">Default</Button>'}
          <br />
          {'<Button size="large">Large</Button>'}
          <br />
          {'<Button size="extraLarge">Extra Large</Button>'}
        </code>
      </Row>
    </>
  );
};

export default Sizes;
